import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import cyzsIndex from './menu/cyzsIndex';
import myself from './menu/myself';
import cyzsTopic from './menu/cyzsTopic';
import cyzsArticle from './menu/cyzsArticle';
import contentManage from './menu/contentManage';
import systemSetting from './menu/systemSetting';
import pushCenter from './menu/pushCenter';
import activity from './menu/activity';
// import icyTalents from './menu/icyTalents';
import customerServices from './menu/customerServices';
import subscriptions from './menu/subscriptions';
import icySysSetting from './menu/icySysSetting';
import fashion from './menu/fashion';
import thirdGoods from './menu/thirdGoods';
import innerGoods from './menu/innerGoods';
import promotions from './menu/promotions';
import wxAppSwitch from './menu/wxAppSwitch';

Vue.use(VueRouter);
const router = new VueRouter({
  saveScrollPosition: true,
  transitionOnLoad: true,
  linkActiveClass: 'is-active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  routes: [
    ...thirdGoods,
    ...customerServices,
    ...subscriptions,
    ...innerGoods,
    ...activity,
    // ...icyTalents,
    ...cyzsIndex,
    ...fashion,
    ...myself,
    ...cyzsTopic,
    ...cyzsArticle,
    ...contentManage,
    ...systemSetting,
    ...pushCenter,
    ...icySysSetting,
    ...promotions,
    ...wxAppSwitch,
    {
      path: '/session',
      name: 'session',
      meta: {
        title: '本地Session同步'
      },
      component(resolve) {
        require(['COMPONENTS/common/session.vue'], resolve)
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        title: 'dashboard'
      },
      component(resolve) {
        require(['COMPONENTS/dashboard/main.vue'], resolve)
      }
    },
    {
      path: '*',
      redirect: '/dashboard'
    },

  ]
})
// router钩子函数
router.beforeEach((to, from, next) => {
  if(location.host.indexOf('local') == -1 && location.href.indexOf('https://') == -1){
    location.href = location.href.replace('http:','https:')

  }
  NProgress.start();
  next();
});
router.afterEach(() => {
  NProgress.done();
});


export default router;
